import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthenticationService } from './contracts/authentication-service.contract';
import { PasswordService } from './contracts/password-service.contract';
import { RegistrationService } from './contracts/registration-service.contract';
import { SessionService } from './contracts/session-service.contract';
import { TokenService } from './contracts/token-service.contract';
import { UserProfileServiceContract } from './contracts/user-profile-service.contract';
import { ApiAuthenticationService } from './services/api-authentication.service';
import { ApiPasswordService } from './services/api-password.service';
import { ApiRegistrationService } from './services/api-registration.service';
import { ApiTokenService } from './services/api-token.service';
import { CookieSessionService } from './services/cookie-session.service';
import { UserProfileService } from './services/user-profile.service';

import { LoggerModule } from '@innovation-os-ng/core/logger';
import { UtilNgModule } from '@innovation-os-ng/core/utils';
import { UserHistoryService } from './contracts/user-history.contract';
import { RemoteSessionService } from './services/remote-session.service';

@NgModule({
  imports: [UtilNgModule, CommonModule, LoggerModule],
  declarations: [],
  exports: [],
  providers: [
    { provide: AuthenticationService, useClass: ApiAuthenticationService },
    { provide: SessionService, useClass: CookieSessionService },
    { provide: TokenService, useClass: ApiTokenService },
    { provide: PasswordService, useClass: ApiPasswordService },
    { provide: UserProfileServiceContract, useClass: UserProfileService },
    { provide: RegistrationService, useClass: ApiRegistrationService },
    { provide: UserHistoryService, useClass: RemoteSessionService }
  ]
})
export class AuthorizationNgModule {}
